module.exports = __webpack_public_path__ + "img/3_7.d46028f8.png";